import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fd0e8d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-lg-7 bg-gray mb-3 mb-lg-5 p-4 position-relative" }
const _hoisted_4 = { class: "text-center fw-bold h3-heading" }
const _hoisted_5 = { class: "text-center mb-4 h4-heading" }
const _hoisted_6 = { class: "row mb-4 mb-lg-2" }
const _hoisted_7 = { class: "col-lg-4 text-center text-lg-start fs-7" }
const _hoisted_8 = { class: "col-lg-8 text-center text-lg-start fs-7 text-break" }
const _hoisted_9 = { class: "row mb-4 mb-lg-2" }
const _hoisted_10 = { class: "col-lg-4 text-center text-lg-start fs-7" }
const _hoisted_11 = { class: "col-lg-8 text-center text-lg-start fs-7" }
const _hoisted_12 = { class: "row d-lg-flex justify-content-center align-items-center" }
const _hoisted_13 = { class: "col-lg-6 d-flex justify-content-center" }

import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'
import dayjs from 'dayjs'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { COMMUNITY_STORE } from '@/store/constants'
import ProfileUserModal from '@/views/user/account/profile/setting/components/ProfileUserModal.vue'
import { CommunityStateTypes } from '@/store/modules/community'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const me = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME])

const transitToEdit = () => {
  window.open('/community/account/profile/edit', '_blank')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(me)?.profile?.display_name), 1),
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_unref(me)?.profile?.display_name_kana), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(translate)('email')), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(me)?.profile?.email), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(dayjs)(_unref(me)?.profile?.birthday).format('YYYY年M月D日')), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(Button, {
                title: _unref(translate)('accountSetting'),
                type: 'secondary',
                size: 'small',
                onClick: transitToEdit
              }, null, 8, ["title"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(ProfileUserModal)
  ], 64))
}
}

})